import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var DeleteVendorVehicleRes;
export const DeleteVendorVehicleTodo = createAsyncThunk('DeleteVendorVehicle', async (id) => {
    // console.log("data", data)
    try {
        const res = await axios({
            method: "Delete",
            url: process.env.REACT_APP_API_URL + `ven_vehicle_data/${id}`,
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + localStorage.getItem('user_token') }
        })
        return DeleteVendorVehicleRes = res.data

    } catch (error) {
        return DeleteVendorVehicleRes = error.response.data
    }
})
